import React from 'react';
import Reveal from '../../../shared/Reveal/Reveal';
import './Explore.css';

const Explore = () => {
  const handleApply = () => {
    const formSection = document.getElementById('partnership-inquiry');
    formSection?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section className="explore">
      <div className="explore__inner">
        <Reveal className="explore__content">
          <h2 className="explore__title">
            Ready to Explore a Partnership With VBS?
          </h2>
          <p className="explore__text">
            Submit your inquiry and our team will follow up with the next steps.
          </p>
          <button
            type="button"
            className="explore__cta luxury-btn"
            onClick={handleApply}
          >
            Apply for Partnership
          </button>
        </Reveal>
      </div>
    </section>
  );
};

export default Explore;
